/** @format */

import * as React from "react";
import { Flex, Center, Link, Image, Text } from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import colors from "@src/style/colors";
import theme from "@src/style/theme";

export const Partner_EN: React.FC = () => {
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };

  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      bgColor={colors.newGray}
      paddingX={basePaddingX}
      paddingY={"50px"}>
      <Flex
        maxWidth={theme.breakpoints.mx}
        width={"100%"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}>
        <Text
          fontSize={{
            base: "14px",
            sm: "18px",
            md: "24px",
            lg: "32px"
          }}
          wordBreak={"keep-all"}
          fontWeight={"500"}
          pb={{
            base: "20px",
            sm: "40px"
          }}
          color={colors.coolGray200}>
          Backed by leading partners
        </Text>
        <Flex
          wrap={"wrap"}
          flexDirection={"row"}
          justifyContent={"space-around"}
          alignItems={"center"}
          gap={"20px"}
          pt={"20px"}>
          {commonInfo.partner.items.map((item, index) => (
            <Link
              href={item.url}
              flexBasis={"calc(100%/4 - 20px)"}
              width={"10vw"}
              isExternal
              key={index}>
              <Center>
                <Image
                  objectFit={"contain"}
                  src={item.image}
                  align={"center"}
                  fallbackSrc="https://via.placeholder.com/250x90"
                />
              </Center>
            </Link>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Partner_EN;
